import React from 'react';
import {Available} from './Available';
import {SeemsAvailable} from './SeemsAvailable';
import {Unavailable} from './Unavailable';
import {Unknown} from './Unknown';

export type MapIndicatorKey = 'Available' | 'SeemsAvailable' | 'Unavailable' | 'Unknown';

export const MapIndicatorIllustration: Record<MapIndicatorKey, typeof Available> = {
  Available,
  SeemsAvailable,
  Unavailable,
  Unknown,
};
